import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { clearUserSession, logoutUserSession } from '../Auth/userSession';
import { deleteAccount } from './myPageApi';

// 회원 탈퇴 확인 폼. 비밀번호가 있는 계정은 비밀번호를 받고, 안내 동의 후에만 탈퇴를 요청한다.
export default function WithdrawForm({ hasPassword, onCancel }) {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [agreed, setAgreed] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const formValid = agreed && (!hasPassword || password.length > 0);

    // 탈퇴를 요청하고, 성공하면 세션을 정리한 뒤 홈으로 보낸다.
    async function submit(event) {
        event.preventDefault();
        if (!formValid || submitting) return;
        if (!window.confirm('정말 탈퇴하시겠습니까?')) return;
        setSubmitting(true);
        setError('');
        try {
            await deleteAccount(hasPassword ? { password } : {});
        } catch (submitError) {
            setError(submitError.message);
            setSubmitting(false);
            return;
        }
        window.alert('탈퇴가 완료되었습니다. 그동안 이용해주셔서 감사합니다.');
        // 이동을 먼저 해서 RequireLogin의 로그인 안내창이 뜨지 않게 한다.
        navigate('/', { replace: true });
        await logoutUserSession().catch(clearUserSession);
    }

    return <form className="my-page-form my-page-inline-form" onSubmit={submit} noValidate>
        <ul className="my-page-warning">
            <li>탈퇴하면 계정이 비활성화되어 다시 로그인할 수 없습니다.</li>
            <li>AI 내담자 면담 기록, 반영 연습 기록, 피드백을 더 이상 확인할 수 없습니다.</li>
        </ul>
        {hasPassword && <label><span>비밀번호 확인</span><input type="password" value={password} onChange={event => setPassword(event.target.value)} disabled={submitting} required maxLength={72} autoComplete="current-password" /></label>}
        <label className="my-page-check"><input type="checkbox" checked={agreed} onChange={event => setAgreed(event.target.checked)} disabled={submitting} /><span>위 안내를 확인했으며 탈퇴에 동의합니다.</span></label>
        {error && <p className="my-page-field-error" role="alert">{error}</p>}
        <div className="my-page-form-actions"><button type="button" className="my-page-button" disabled={submitting} onClick={onCancel}>취소</button><button type="submit" className="my-page-button danger" disabled={!formValid || submitting}>{submitting ? '처리 중…' : '탈퇴하기'}</button></div>
    </form>;
}

WithdrawForm.propTypes = {
    hasPassword: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
};
